import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applyStoredFontSize } from './hooks/useFontSize';
import '@mdi/font/css/materialdesignicons.min.css';
import './styles/globals.css';

// The stored font size applies to every page, not only the one where it can be chosen. Without
// this call the setting did nothing anywhere else, because the hook that applies it is mounted in
// a single card on the account page.
applyStoredFontSize();

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
